import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import { calendarOperations } from "../../../modules/definition/calendar";
import { PropTypeShapes } from "../../../types";
import CalendarSettingsMonthDetailView from "./CalendarSettingsMonthDetailView";

const CalendarSettingsMonthTab = props => {
  const items = props.listItems(props.months).map(month => ({ ...month, canDelete: props.months.count() > 1 }));

  return (
    <ModalMasterDetailView
      items={items}
      onAddClick={props.canEditDateData ? props.onAddMonth : null}
      onDeleteClick={props.canEditDateData ? props.onRemoveMonth : null}
      canEditDateData={props.canEditDateData}
      allowDrag={props.canEditDateData}
      onMoveItemAtIndex={props.onMoveMonth}
      backText="Months"
      itemsUseIndexAsId={true}
      //#!if iOS === true
// onDoneClick={props.onDoneClick}
      //#!endif
    >
      <CalendarSettingsMonthDetailView {...props} />
    </ModalMasterDetailView>
  );
};

CalendarSettingsMonthTab.propTypes = {
  localStore: PropTypes.object,
  months: ImmutablePropTypes.listOf(PropTypeShapes.month).isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onAddMonth: PropTypes.func.isRequired,
  onMoveMonth: PropTypes.func.isRequired,
  onRemoveMonth: PropTypes.func.isRequired,
  onMonthNameChange: PropTypes.func.isRequired,
  onMonthShortNameChange: PropTypes.func.isRequired,
  onMonthDurationChange: PropTypes.func.isRequired,
  onMonthLeapDurationChange: PropTypes.func.isRequired,
  listItems: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired
  //#!endif
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onAddMonth: index => {
      props.dispatchLocal(
        calendarOperations.addMonthAtIndex(_.isNil(index) || index < 0 ? props.months.size : index + 1)
      );
    },
    onMoveMonth: (fromIndex, toIndex) => {
      props.dispatchLocal(calendarOperations.moveMonth(fromIndex, toIndex));
    },
    onRemoveMonth: index => {
      props.dispatchLocal(calendarOperations.deleteMonthAtIndex(index));
    },
    onMonthNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editMonthName(index, name));
    },
    onMonthShortNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editMonthShortName(index, name));
    },
    onMonthDurationChange: (index, duration) => {
      props.dispatchLocal(calendarOperations.editMonthDuration(index, Number(duration)));
    },
    onMonthLeapDurationChange: (index, duration) => {
      props.dispatchLocal(calendarOperations.editMonthLeapDuration(index, duration));
    }
  };
};

export default connect(null, mapDispatchToProps)(CalendarSettingsMonthTab);
